<template>
  <b-modal v-model="show" size="lg" :title="$t('realEstate.field.constructionCompletion')"
           no-close-on-backdrop no-close-on-esc hide-header-close
           hide-footer>
    <div class="container-fluid">
      <div class="row">

        <div class="col-12">
          <div class="form-group">
            <label :class="$v.constructionCompletion.$error ? 'text-danger' : ''">
              {{$t('realEstate.field.percentage')}}<span class="text-danger">*</span>
            </label>
            <numeric-input v-model="constructionCompletion"
                           :max="100"
                           :min="1"
                           :precision="2"
                           :class="{invalid: $v.constructionCompletion.$error}"
            ></numeric-input>
          </div>
        </div>

        <div class="col-12">
          <div class="form-group">
            <RealEstateDropZone code="constructionCompletionDoc"
                            label="realEstate.field.constructionCompletionDoc"
                            :folder="'ConstructionCompletionDoc'"
                            :data="constructionCompletionDoc"
                            @change="(files) => {constructionCompletionDoc = files}"
                            :has-error="$v.constructionCompletionDoc.$error"
            />
            <div class="text-danger" v-if="$v.constructionCompletionDoc.$error">
              {{$t("realEstate.field.constructionCompletionDoc")}}
            </div>
          </div>
        </div>

        <div class="col-12 d-flex justify-content-center mt-4">
          <button class="all-btn btn-success ml-2" :disabled="processing" @click="acceptPercentageData">
            {{$t('realEstate.action.confirm')}}
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {validationMixin} from 'vuelidate';
import {maxValue, minValue, required, minLength} from "vuelidate/lib/validators";
import RealEstateDropZone from "@/views/real-estate/RealEstateDropZone.vue";
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
export default {
  name: "ConstructionCompletionPercentageModal",
  mixins: [validationMixin],
  components: {
    'b-modal': bModal,
    RealEstateDropZone
  },
  directives: {
    'b-modal': bModalDirective
  },
  data() {
    return {
      show: false,
      processing: false,
      constructionCompletion: null,
      constructionCompletionDoc: [],
    }
  },
  validations() {
    return {
      constructionCompletion: {
        required: required,
        min: minValue(1),
        max: maxValue(100)
      },
      constructionCompletionDoc: {
        required: required,
        minLength: minLength(1)
      }
    }
  },
  methods: {
    acceptPercentageData() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$emit('handle-completion-data', {constructionCompletion: this.constructionCompletion, constructionCompletionDoc: this.constructionCompletionDoc})
      this.constructionCompletion = 0
      this.constructionCompletionDoc = []
      this.show = false
    },
  },
  created() {
    this.$eventBus.$on('showConstructionCompletionPercentageModal', () => {
      this.show = true;

    })
  },
  beforeDestroy() {
    this.$eventBus.$off('showConstructionCompletionPercentageModal')
  }
}
</script>

<style scoped>

</style>
